import React, { useEffect, useState } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import {
  Button,
  TextField,
  MenuItem,
  Typography,
  Paper,
  Modal,
  Box,
} from "@material-ui/core";
import { createOnBoardingTask, updateOnBoardingTask } from "@redux/actions";
import { useDispatch } from "react-redux";
import { modalBody, modalHeader, modalStyle } from "@styles/styledComponents";

const styles = (theme) => ({
  paper: {
    boxShadow: "none !important",
  },
  form: {
    paddingRight: theme.spacing.unit * 1,
  },
  submitButton: {
    margin: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
  },
  textField: {
    marginLeft: theme.spacing.unit * 1,
    marginTop: theme.spacing.unit * 1,
  },
});

const BoardingTasksModal = ({
  tasksModal,
  setTasksModal,
  isUpdate,
  setSelectedTask,
  selectedTask,
  allCategories,
  transitionType,
  classes,
}) => {
  const [task, setTask] = useState({});
  const dispatch = useDispatch();

  const createTask = () => {
    dispatch(
      createOnBoardingTask({ task: task, category_type: transitionType })
    ).then(() => {
      handleCloseModal();
    });
  };

  const updateTask = () => {
    dispatch(
      updateOnBoardingTask({ task: task, category_type: transitionType })
    ).then(() => {
      handleCloseModal();
    });
  };

  const handleSubmitForm = (event) => {
    event.preventDefault();
    setSelectedTask(null);
    isUpdate ? updateTask() : createTask();
  };

  function handleTaskInputs(event) {
    const { name, value } = event.target;
    setTask((pre) => {
      return {
        ...pre,
        [name]: value,
      };
    });
  }

  function handleCloseModal() {
    setTask({
      category_id: "",
      name: "",
      status: true,
      comment: "",
    });
    setSelectedTask(null);
    setTasksModal(false);
  }

  useEffect(() => {
    if (selectedTask) {
      const { name, status, category_id, comment, task_id } = selectedTask;
      setTask({
        category_id: category_id,
        id: task_id,
        name: name,
        status: status,
        comment: comment,
      });
    } else {
      setTask({
        category_id: "",
        name: "",
        status: true,
        comment: "",
      });
    }
  }, [selectedTask]);

  return (
    <Modal
      open={tasksModal}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      style={modalStyle}
    >
      <Paper elevation={1} variant="normal" square>
        <div style={modalHeader}>
          <Typography variant="h5">
            {isUpdate ? "Update " : "Add "} Task
          </Typography>
        </div>
        <div style={modalBody}>
          <Paper className={classes.paper}>
            <form
              autoComplete="off"
              className={classes.form}
              onSubmit={handleSubmitForm}
            >
              <TextField
                id="task_name"
                name="name"
                label="Task Name"
                fullWidth
                required={!isUpdate}
                className={classes.textField}
                defaultValue={task.name}
                onChange={handleTaskInputs}
                margin="normal"
              />
              <TextField
                label="Choose Category"
                name="category_id"
                variant="standard"
                fullWidth
                value={task.category_id}
                className={classes.textField}
                select
                required
                disabled={isUpdate}
                onChange={handleTaskInputs}
              >
                {allCategories.length &&
                  allCategories.map((category, index) => {
                    return (
                      <MenuItem key={index} value={category._id}>
                        {category.name}
                      </MenuItem>
                    );
                  })}
              </TextField>
              <TextField
                id="comment"
                name="comment"
                label="Comment"
                placeholder="Please enter who is responsible for this task"
                fullWidth
                required
                className={classes.textField}
                defaultValue={task.comment}
                onChange={handleTaskInputs}
                margin="normal"
              />
              <TextField
                label="Choose Status"
                variant="standard"
                name="status"
                fullWidth
                value={task.status}
                className={classes.textField}
                select
                onChange={handleTaskInputs}
              >
                <MenuItem value={true}>activate</MenuItem>
                <MenuItem value={false}>deactivate</MenuItem>
              </TextField>
              <Box display="flex" justifyContent="flex-end" alignItems="center">
                {isUpdate ? (
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.submitButton}
                  >
                    Update
                  </Button>
                ) : (
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.submitButton}
                  >
                    Create
                  </Button>
                )}

                <Button
                  type="button"
                  variant="contained"
                  color="primary"
                  className={classes.submitButton}
                  onClick={handleCloseModal}
                >
                  Close
                </Button>
              </Box>
            </form>
          </Paper>
        </div>
      </Paper>
    </Modal>
  );
};

export default withStyles(styles)(BoardingTasksModal);
